/* Мягкая карточка на главной и экран выбора любимых (HQ-726). Кнопки — цвет кнопки Telegram (themeParams). */
.card { display: flex; flex-direction: column; gap: var(--space-2); padding: var(--space-4); border-radius: var(--radius-card);
  background: var(--surface); }
.inset { padding: var(--space-3) var(--space-3) 0; }
.cardTitle { font-size: var(--fs-callout); line-height: 1.313; font-weight: 600; }
.cardText { font-size: var(--fs-footnote); line-height: 1.385; color: var(--content-secondary); }
.cardActions { display: flex; gap: var(--space-2); margin-top: var(--space-1); }
.cardActions > * { flex: 1; }

.primary { display: inline-flex; align-items: center; justify-content: center; gap: var(--space-2); min-height: 44px; padding: 0 var(--space-4);
  border-radius: var(--radius-button); background: var(--tg-button-color, var(--accent)); color: var(--tg-button-text-color, var(--on-accent));
  font-size: var(--fs-subheadline); font-weight: 600; }
.primary:disabled { opacity: 0.45; }
.secondary { min-height: 44px; padding: 0 var(--space-4); border-radius: var(--radius-button); background: var(--ground);
  color: var(--content-primary); font-size: var(--fs-subheadline); font-weight: 600; }
.count { display: inline-flex; align-items: center; justify-content: center; min-width: 22px; min-height: 22px;
  padding: 0 6px; border-radius: 11px; background: color-mix(in srgb, currentColor 18%, transparent);
  font-size: var(--fs-footnote); line-height: 1.693; text-align: center; }

.page { display: flex; flex-direction: column; gap: var(--space-3); padding: var(--space-3) var(--space-4) 0; }
.progress { display: flex; gap: 4px; }
.segment { flex: 1; height: 4px; border-radius: 2px; background: var(--content-border); }
.segmentOn { background: var(--tg-button-color, var(--accent)); }
.title { margin: 0; font-size: var(--fs-title); line-height: 1.25; font-weight: 700; }
.list { display: flex; flex-direction: column; }

.row { display: flex; align-items: center; gap: var(--space-3); min-height: 56px; padding: 6px 0; cursor: pointer; }
.row + .row, .group + .group { border-top: 0.5px solid var(--content-border); }
.rowText { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.rowName { font-size: var(--fs-subheadline); line-height: 1.334; font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.rowCaption { display: flex; align-items: center; gap: 6px; font-size: var(--fs-footnote); line-height: 1.385; color: var(--content-secondary);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.groupHeader { display: flex; align-items: center; gap: var(--space-3); width: 100%; min-height: 52px; text-align: left; }
.groupHeader > .rowName { flex: 1; min-width: 0; }
.group .row { padding-left: var(--space-4); border-top: 0.5px solid var(--content-border); }
.flagBox { flex: none; display: inline-flex; width: 20px; }
.groupCount { display: inline-flex; align-items: center; justify-content: center; min-width: 22px; min-height: 22px;
  padding: 0 6px; border-radius: 11px; background: var(--ground);
  font-size: var(--fs-footnote); line-height: 1.693; text-align: center; font-weight: 600; }
.chevron { width: 8px; height: 8px; margin: 0 var(--space-2); border-right: 2px solid var(--content-secondary);
  border-bottom: 2px solid var(--content-secondary); transform: rotate(45deg); transition: transform 0.2s; }
.chevronOpen { transform: rotate(-135deg); }

/* Кнопки шага — над нижней панелью вкладок, прилипают к низу прокрутки */
.footer { position: sticky; bottom: calc(var(--tabbar-height) + var(--tg-safe-bottom)); z-index: 5; display: flex; gap: var(--space-2);
  margin: 0 calc(-1 * var(--space-4)); padding: var(--space-3) var(--space-4); background: var(--ground); }
.footer > .secondary { background: var(--surface); }
.footer > .primary { flex: 1; }
